export default __webpack_public_path__ + "static/media/IMAGE_14.0e02632d.png";